<template>
    <div class="main-wrapper">
        <bread-cumb/>
        <div class="container">
            <head-resume/>
            <div class="row mt-30">
                <billing-information/>
                <room-information/>
                <div class="text-right mb-50">
                    <router-link to="/" class="btn btn-lg btn-icon">Finalizar<span class="icon"><i
                            class="pe-7s-angle-right"></i></span></router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import breadCumb from '../components/confirmation/breadCumb'
    import headResume from '../components/confirmation/headResume'
    import billingInformation from '../components/confirmation/billingInformation'
    import roomInformation from '../components/confirmation/roomInformation'

    export default {
        name: "confirmation",
        components: {breadCumb, headResume, billingInformation, roomInformation}
    }
</script>

<style scoped>
    .btn-icon {
        background: #8ac6c4 !important;
    }

    .btn-icon:hover {
        color: #FFF !important;
    }
</style>